import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/neon-button';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  return (
    <div className="flex space-x-2">
      {['en', 'ru', 'lv'].map((lang) => (
        <Button
          key={lang}
          variant={i18n.language === lang ? 'solid' : 'ghost'}
          size="sm"
          onClick={() => i18n.changeLanguage(lang)}
          className="uppercase"
        >
          {lang}
        </Button>
      ))}
    </div>
  );
};

export default LanguageSelector;